module.exports = __webpack_public_path__ + "img/Captura de tela 2023-05-16 153334-fotor-bg-remover-20230516153425.4565743f.png";